export type BranchStatus =
  | 'green' // 'success'
  | 'yellow' // 'created', 'running'
  | 'red'; //  'error', 'failed'
